module.exports = __webpack_public_path__ + "img/ico-plus-hours.c3a75310.svg";